import React, { useState } from 'react';
import Navbar from '../components/Navbar';
import './RSVP.css';

const RSVP = () => {
    // Example guest list with allowed +1
    const allowedGuests = [
        { name: "Adam Rashbaum", plusOne: true },
        { name: "Adam Stern", plusOne: true },
        { name: "Aimee Gomez", plusOne: true },
        { name: "Alan Sotnick", plusOne: true },
        { name: "Alex Decilveo", plusOne: true },
        { name: "Alexander Decilveo", plusOne: true },
        { name: "Andrew Huebscher", plusOne: true },
        { name: "Andy Ryan", plusOne: false },
        { name: "Andrew Ryan", plusOne: false },
        { name: "Anna Decilveo", plusOne: false },
        { name: "Annie Villardi", plusOne: true },
        { name: "Barbara Sotnick", plusOne: true },
        { name: "Bert Eitner", plusOne: true },
        { name: "Bia Eitner", plusOne: true },
        { name: "Roberta Eitner", plusOne: true },
        { name: "Bob Munier", plusOne: true },
        { name: "Robert Munier", plusOne: true },
        { name: "Brendan Kelly", plusOne: true },
        { name: "Brooke Evans", plusOne: true },
        { name: "Brooke Posess", plusOne: true },
        { name: "Bud Williams", plusOne: true },
        { name: "Charlena Powell", plusOne: true },
        { name: "Charlie Habegger", plusOne: true },
        { name: "Chris Earle", plusOne: true },
        { name: "Christina Antonio", plusOne: true },
        { name: "Claire Ramirez", plusOne: true },
        { name: "Dan Berardo", plusOne: false },
        { name: "Daniel Berardo", plusOne: false },
        { name: "Derek King", plusOne: true },
        { name: "Devon Aguirre", plusOne: false },
        { name: "Diana Moffa", plusOne: true },
        { name: "DJ Hartigan", plusOne: true },
        { name: "D.J. Hartigan", plusOne: true },
        { name: "Ed Quintavalle", plusOne: true },
        { name: "Mahlia Hardy", plusOne: true },
        { name: "Em Hardy", plusOne: true },
        { name: "Eric Bail", plusOne: true },
        { name: "Erika Aronson", plusOne: true },
        { name: "Erika Stern", plusOne: true },
        { name: "Erika Aronson Stern", plusOne: true },
        { name: "Erika Aronson-Stern", plusOne: true },
        { name: "Eva Stern", plusOne: true },
        { name: "Gabrielle Rashbaum", plusOne: true },
        { name: "Gab Rashbaum", plusOne: true },
        { name: "Gabrielle Faessler", plusOne: true },
        { name: "Gab Faessler", plusOne: true },
        { name: "Garrett Neilsen", plusOne: true },
        { name: "Geoff Posess", plusOne: true },
        { name: "Geoffrey Posess", plusOne: true },
        { name: "Gerald Powell", plusOne: true },
        { name: "Gia Vargas", plusOne: true },
        { name: "Giannina Vargas", plusOne: true },
        { name: "Giselle Zarrinkouh", plusOne: true },
        { name: "Gizzy Zarrinkouh", plusOne: true },
        { name: "Jackie Juhn", plusOne: true },
        { name: "Jacob Aguirre", plusOne: true },
        { name: "James Lindsay", plusOne: true },
        { name: "Jan Amick", plusOne: false },
        { name: "Jason Oclaray", plusOne: true },
        { name: "Jeannette Aguirre", plusOne: false },
        { name: "Jen De Gregori", plusOne: true },
        { name: "Jen Sotnick", plusOne: true },
        { name: "Jenn Decilveo", plusOne: true },
        { name: "John Adams", plusOne: true },
        { name: "Jordan Bakva", plusOne: true },
        { name: "Julie Kelly", plusOne: true },
        { name: "Kaelani Lujan", plusOne: true },
        { name: "Katie Hahn", plusOne: true },
        { name: "Kyle Schroeder", plusOne: true },
        { name: "Lee Barden", plusOne: true },
        { name: "Lena Sotnick", plusOne: true },
        { name: "Liz Munier", plusOne: true },
        { name: "Liz Puleo", plusOne: true },
        { name: "Elizabeth Munier", plusOne: true },
        { name: "Elizabeth Puleo", plusOne: true },
        { name: "Loren DeFalco", plusOne: true },
        { name: "Lori Quintavalle", plusOne: true },
        { name: "Luis Huerta", plusOne: false },
        { name: "Marc Stern", plusOne: true },
        { name: "Marcus Aguirre", plusOne: true },
        { name: "Margarethe Smith", plusOne: true },
        { name: "Maria Dorney", plusOne: true },
        { name: "Mark Kovach", plusOne: true },
        { name: "Mary Negrete", plusOne: false },
        { name: "Manny Labour", plusOne: false },
        { name: "Matt Hardy", plusOne: true },
        { name: "Melissa Habegger Ryan", plusOne: true },
        { name: "Melissa Ryan", plusOne: true },
        { name: "Melissa Habegger", plusOne: true },
        { name: "Michael Lubin", plusOne: true },
        { name: "Michael McCarthy", plusOne: true },
        { name: "Mike McCarthy", plusOne: true },
        { name: "Mike Smith", plusOne: true },
        { name: "Morgan Powell", plusOne: false },
        { name: "Nicole Archer", plusOne: true },
        { name: "Nicole King", plusOne: true },
        { name: "Nicole LaGuardia", plusOne: true },
        { name: "Nicole Negrete", plusOne: true },
        { name: "Ohleena Paea", plusOne: false },
        { name: "Patrick Ward", plusOne: true },
        { name: "Pete Cento", plusOne: true },
        { name: "Priscilla Ward", plusOne: true },
        { name: "Rachel Lindsay", plusOne: true },
        { name: "Ronda Lubin", plusOne: true },
        { name: "Sally Gamble", plusOne: false },
        { name: "Sam Cento", plusOne: true },
        { name: "Sam Sotnick", plusOne: true },
        { name: "Shirley Weiner", plusOne: false },
        { name: "Steff Woolf", plusOne: false },
        { name: "Stephanie Woolf", plusOne: false },
        { name: "Steve Gilison", plusOne: true },
        { name: "Steve Ryan", plusOne: false },
        { name: "Suzy Gilison", plusOne: true },
        { name: "Tavi Shabestari", plusOne: true },
        { name: "Taylor Kovach", plusOne: false },
        { name: "Tom Dorney", plusOne: true },
        { name: "Trisha Williams", plusOne: true },
        { name: "Val Figueroa", plusOne: true },
        { name: "Valerie Figueroa", plusOne: true },
        { name: "Val McCarthy", plusOne: true },
        { name: "Valeria McCarthy", plusOne: true },
        { name: "Veronica Kovach", plusOne: true },
        { name: "Victoria Barden", plusOne: true },
        { name: "Virginia Negrete", plusOne: true },
        { name: "Zachary Archer", plusOne: true },
        { name: "Zach Archer", plusOne: true },
        { name: "Zachary Williams", plusOne: false },
        { name: "Zoe Bail", plusOne: true },
    ];

    const [guest, setGuest] = useState({ firstName: "", lastName: "", foodOption: "", songChoice: "" });
    const [plusOne, setPlusOne] = useState({ firstName: "", lastName: "", foodOption: "" });
    const [isAllowedPlusOne, setIsAllowedPlusOne] = useState(false);
    const [verificationSuccess, setVerificationSuccess] = useState(false);

    const foodOptions = [
        "Chicken breast with poblano sauce.", 
        "Steak with black mole.", 
        "Zucchini and pepper tamale."
    ];

    const handleGuestChange = (e) => {
        const { name, value } = e.target;
        setGuest({ ...guest, [name]: value });
    };

    const handlePlusOneChange = (e) => {
        const { name, value } = e.target;
        setPlusOne({ ...plusOne, [name]: value });
    };

    const handleGuestVerification = () => {
        const fullName = `${guest.firstName.trim()} ${guest.lastName.trim()}`;
        const guestInfo = allowedGuests.find((g) => g.name === fullName);
        if (guestInfo) {
            setIsAllowedPlusOne(guestInfo.plusOne);
            setVerificationSuccess(true); // SET SUCCESS
        } else {
            alert("We couldn't find your RSVP. Please check your spelling and try again.");
            setVerificationSuccess(false); // RESET ON FAILURE
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
    
        const rsvpData = {
            guestName: `${guest.firstName} ${guest.lastName}`,
            guestFoodOption: guest.foodOption,
            guestSongChoice: guest.songChoice,
            plusOneName: isAllowedPlusOne ? `${plusOne.firstName} ${plusOne.lastName}` : "N/A",
            plusOneFoodOption: isAllowedPlusOne ? plusOne.foodOption : "N/A",
        };
        
        try {
            const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/submit-rsvp`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(rsvpData),
            });

            console.log("RSVP data:", rsvpData);

            if (response.ok) {
                alert("RSVP submitted successfully!");
                setGuest({ firstName: "", lastName: "", foodOption: "", songChoice: "" });
                setPlusOne({ firstName: "", lastName: "", foodOption: "" });
                setIsAllowedPlusOne(false);
                setVerificationSuccess(false); // RESET STATE
            } else {
                alert("There was an issue submitting your RSVP. Please try again.");
            }
        } catch (error) {
            console.error("Error submitting RSVP:", error);
            alert("There was an issue submitting your RSVP. Please try again.");
        }
    };

    return (
        <div>
            <Navbar />
            <section className="rsvp section">
                <div className="rsvp-container">
                    <hr className="divider" />
                    <h1 className="section-title">RSVP</h1>
                    <p className="rsvp-by">Please RSVP no later than July 30, 2025</p>
                    <form onSubmit={handleSubmit} className="rsvp-form">
                        <div className="form-row">
                            <div className="form-group">
                                <input
                                    type="text"
                                    id="firstName"
                                    name="firstName"
                                    placeholder="First Name"
                                    value={guest.firstName}
                                    onChange={handleGuestChange}
                                    required
                                />
                            </div>
                            <div className="form-group">
                                <input
                                    type="text"
                                    id="lastName"
                                    name="lastName"
                                    placeholder="Last Name"
                                    value={guest.lastName}
                                    onChange={handleGuestChange}
                                    required
                                />
                            </div>
                        </div>
                        <button type="button" onClick={handleGuestVerification} className="verify-button">
                            Verify RSVP
                        </button>

                        {verificationSuccess && ( // CONDITIONAL RENDERING
                            <>
                                <div className="form-row">
                                    <div className="form-group">
                                        <select
                                            id="foodOption"
                                            name="foodOption"
                                            value={guest.foodOption}
                                            onChange={handleGuestChange}
                                            required
                                        >
                                            <option value="" disabled>
                                                Select your meal
                                            </option>
                                            {foodOptions.map((option, index) => (
                                                <option key={index} value={option}>
                                                    {option}
                                                </option>
                                            ))}
                                        </select>
                                    </div>
                                    <div className="form-group">
                                        <input
                                            type="text"
                                            id="songChoice"
                                            name="songChoice"
                                            value={guest.songChoice}
                                            onChange={handleGuestChange}
                                            placeholder="Enter your favorite song!"
                                        />
                                    </div>
                                </div>
                                {isAllowedPlusOne && (
                                    <>
                                        <h3>Your +1's Details</h3>
                                        <div className="form-row">
                                            <div className="form-group">
                                                <input
                                                    type="text"
                                                    id="plusOneFirstName"
                                                    name="firstName"
                                                    placeholder="Plus One First Name"
                                                    value={plusOne.firstName}
                                                    onChange={handlePlusOneChange}
                                                />
                                            </div>
                                            <div className="form-group">
                                                <input
                                                    type="text"
                                                    id="plusOneLastName"
                                                    name="lastName"
                                                    placeholder="Plus One Last Name"
                                                    value={plusOne.lastName}
                                                    onChange={handlePlusOneChange}
                                                />
                                            </div>
                                        </div>
                                        <div className="form-row">
                                            <div className="form-group">
                                                <select
                                                    id="plusOneFoodOption"
                                                    name="foodOption"
                                                    value={plusOne.foodOption}
                                                    onChange={handlePlusOneChange}
                                                >
                                                    <option value="" disabled>
                                                        Select a meal
                                                    </option>
                                                    {foodOptions.map((option, index) => (
                                                        <option key={index} value={option}>
                                                            {option}
                                                        </option>
                                                    ))}
                                                </select>
                                            </div>
                                        </div>
                                    </>
                                )}
                                <button type="submit" className="submit-button">
                                    Submit RSVP
                                </button>
                            </>
                        )}
                    </form>
                    <hr className="divider" />
                </div>
            </section>
        </div>
    );
};

export default RSVP;